import React from 'react';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';

export const CroAddButton = ({ disabled, onClick, className }) => (
  <Button
    variant="outlined"
    size="small"
    startIcon={<AddIcon />}
    disabled={disabled}
    onClick={onClick}
    className={className}
  >
    Přidat záznam
  </Button>
);

export const CroRemoveButton = ({ onClick, disabled, className }) => (
  <IconButton
    size="small"
    onClick={onClick}
    disabled={disabled}
    className={className || 'cro-array-remove'}
    aria-label="Odebrat záznam"
  >
    <CloseIcon fontSize="small" />
  </IconButton>
);
